import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react"
import axiosInstance from "../../../utils/axiosInstance";

const Subscriptions = () => {
    const [requests, setRequests] = useState([
        {
            subscription_id: '',
            membership_id: '',
            plan_id: '',
            status: '',
            start_date: '',
            end_date: '',
            createdAt: '',
        }
    ]);
    const getrequestsRef = useRef()

    const [participants, setParticipants] = useState([
        {
            participant_id: '',
            name: '',
            role: ''
        }
    ])
    const [plans, setPlans] = useState([{
        plan_id: '',
        title: ''
    }])
    // const [searchQuery, setSearchQuery] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const filteredrequests = requests
    // .filter((request) =>
    //     request?.membership_id.toLowerCase().includes(searchQuery.toLowerCase()) || request?.plan_id.toLowerCase().includes(searchQuery.toLowerCase())
    // );

    const paginatedRequests = filteredrequests.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getPlanName = (id) => {
        return plans.find((plan) => plan.plan_id === id)?.title || '';
    }
    
    const getParticipantName = (id) => {
        const participant = participants.find((participant) => participant.guest_id || participant.membership_id === id);
        return participant?.name || 'Unknown Participant';
    }

    useEffect(() => {
        const getParticipants = async () => {
            await axiosInstance.get(`auth/all_users`).then((response) => {
                setParticipants(response.data.users);
            }).catch((e) => {
                setParticipants([])
            })
        }

        const getrequests = async () => {
            await axiosInstance.get(`membershipsubscription/all`).then((result) => {
                setRequests(result.data.data);
            }).catch(() => {
                setRequests([])
            })
        }

        const getPlans = async () => {
            await axiosInstance.get(`plans/all`).then((response) => {
                setPlans(response.data.data);
            }).catch((error) => {
                if (error.response && error.response.data.message === "No plans found") {
                    setPlans([]);
                } else if (error.response && error.response.data.message !== "No plans found") {
                    setPlans([]);
                } else {
                    setPlans([]);
                }
            });
        }

        getrequestsRef.current = getrequests;

        getPlans();
        getrequests();
        getParticipants()
    }, [])

    return(
        <div>
            <div className="md:flex justify-between md:flex-wrap">
                <Typography variant='h4' className="text-blue-800">Manage requests</Typography>
            </div>

            <div className="p-4">
                {/* <TextField label="Search for requests by client, manager who received requests" variant="outlined" fullWidth value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} /> */}
                <TableContainer component={Paper} className="shadow mt-4" sx={{ color: "#1f2937" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Plan</TableCell>
                                <TableCell>Start date</TableCell>
                                <TableCell>End Date</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Sent date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedRequests.reverse().map((request, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index+1}</TableCell>
                                    <TableCell>{getParticipantName(request?.membership_id)}</TableCell>
                                    <TableCell>{getPlanName(request?.plan_id) || <i style={{ color: "red" }}>NOT FOUND</i>}</TableCell>
                                    <TableCell>{request?.start_date.slice(0,10)}</TableCell>
                                    <TableCell>{request?.end_date.slice(0,10)}</TableCell>
                                    <TableCell>{request?.status === 'active' ? <span className='text-white bg-green-700 p-2 rounded-full px-3'>Active</span> : <span className='text-white bg-red-700 p-2 rounded-full px-3'>Inactive</span>}</TableCell>
                                    <TableCell>{request?.createdAt?.slice(0, 10)}</TableCell>
                                </TableRow>
                            ))}
                            {filteredrequests.length === 0 && <TableRow><TableCell colSpan={8} className="text-center">No request found.</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, filteredrequests.length]}
                        component="div"
                        count={filteredrequests.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>
        </div>
    )
}

export default Subscriptions